import { ClientException, ClientExceptionConstructor } from './client-exception';

export class NfcTagCapacityExceededException extends ClientException implements ClientExceptionConstructor {
  constructor(readonly capacityInBytes: number, readonly messageSizeInBytes: number, message?: string, error?: Error) {
    super(message, error);
    this.name = 'NfcTagCapacityExceededException';
  }
}
